import { useLocation, useNavigate } from 'react-router-dom';
import { TabNavigationProps } from 'types/tab.type';
import { tabListProduct } from 'utils/tabButton';

const ProductTabNavigation: React.FC<TabNavigationProps> = ({ tabButtonClass, tabSpanClass, activeKey, id }) => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className='flex overflow-scroll scrollbar-hide gap-[24px] ml-4 mt-2'>
      {tabListProduct.map((tab) =>
        id ? (
          <button
            key={tab.activeKey}
            className={`${tabButtonClass.base} ${
              tab.activeKey === activeKey ? tabButtonClass.active : tabButtonClass.inactive
            }`}
            style={{ minWidth: '139px', height: '48px' }}
            onClick={() => {
              const currentPath = location.pathname.split('?')[0];
              navigate(`${currentPath}?query=${tab.activeKey}`);
            }}
          >
            <span
              className={`${tabSpanClass.base} ${
                tab.activeKey === activeKey ? tabSpanClass.active : tabSpanClass.inactive
              }`}
            >
              {tab.label}
            </span>
          </button>
        ) : (
          <div key={tab.label}>
            <button
              className={`${tabButtonClass.base} ${
                tab.activeKey === activeKey ? tabButtonClass.active : tabButtonClass.inactive
              }`}
              style={{ minWidth: '139px', height: '48px' }}
            >
              <span
                className={`${tabSpanClass.base} ${
                  tab.activeKey === activeKey ? tabSpanClass.active : tabSpanClass.inactive
                }`}
              >
                {tab.label}
              </span>
            </button>
          </div>
        ),
      )}
    </div>
  );
};
export default ProductTabNavigation;
